export default __webpack_public_path__ + "static/media/logo.dcfd38a3.png";